<template lang="pug">
	ul.navbar-nav.tutorial-button(v-if="User.currentUser" :class="{active: !!Tutorial.activeChapter}")
		li.nav-item.px-3
			.account(@click="openTutorial()")
				i.fa.fa-question-circle
				.active-tutorial-stages-count.badge.badge-warning(v-show="Tutorial.getActiveChaptersCount() > 0") {{Tutorial.getActiveChaptersCount()}}
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Tutorial } 		from './../../services/Tutorial'

	export default {
		name: "TutorialButton",
		mixins: [Screen],
		screen: {
			updateOn: ["Server Data Loaded", "Publishers Changed", "Selected Publisher Changed", "Current User Changed", "Current User Changed: [options.features]", "Tutorial Active Chapter Changed", "Tutorial Chapters Changed"]
		},
		components: {
		},
		data() {

			this.Tutorial = Tutorial;

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

			},
			openTutorial() {

				if (Tutorial.activeChapter) Tutorial.cancelChapter();

				Broadcast.call("Show Tutorial");

			}
		}
	}
</script>

<style lang="sass">

	ul.tutorial-button
		list-style: none
		position: relative

		i.fa
			width: 35px
			height: 35px
			border-radius: 35px
			cursor: pointer
			font-size: 30px
			color: rgba(255, 255, 255, 0.35)

			&:hover
				color: var(--warning)

		.active-tutorial-stages-count
			position: absolute
			right: 5px
			top: -5px

	ul.tutorial-button.active
		i.fa
			color: var(--warning)

</style>

